var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsDownUp = function SvgIconArrowsDownUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5a1 1 0 0 1 1 1v12.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L6.5 17.086V4.5a1 1 0 0 1 1-1M15.793 3.793a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L17.5 6.914V19.5a1 1 0 1 1-2 0V6.914l-1.293 1.293a1 1 0 1 1-1.414-1.414z"
  }))));
};
export default SvgIconArrowsDownUp;